// CSV serialization for Manufacturing → Named variants export (round-trips the
// bulk-import column contract in namedVariantsBulkImportExample.ts).

import type { NamedVariantStatus } from "./namedVariantsClient";

export const NAMED_VARIANT_EXPORT_HEADERS = [
  "variant_code",
  "variant_name",
  "description",
  "status",
] as const;

const NEEDS_QUOTING = /[",\n\r]/;

function escapeCell(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = typeof value === "string" ? value : String(value);
  if (!NEEDS_QUOTING.test(s)) return s;
  return `"${s.replace(/"/g, '""')}"`;
}

function rowsToCsv(headers: readonly string[], rows: Array<Array<unknown>>): string {
  const lines = [headers.join(",")];
  for (const row of rows) {
    lines.push(row.map(escapeCell).join(","));
  }
  return lines.join("\n") + "\n";
}

export type NamedVariantExportRow = {
  code: string;
  name: string;
  description: string;
  status: NamedVariantStatus;
};

/** Header-only CSV from list summary rows (no transform config or applications). */
export function namedVariantsToCsv(variants: ReadonlyArray<NamedVariantExportRow>): string {
  const rows = variants.map((v) => [v.code, v.name, v.description ?? "", v.status]);
  return rowsToCsv(NAMED_VARIANT_EXPORT_HEADERS, rows);
}
